// src/utils/cmsAPI.js
// Strip trailing slash so paths like /api/v1/cms/jobs never become //api/...
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/+$/, '');

/**
 * Helper function to handle image sources (base64 or URL)
 */
export const getImageSrc = (image) => {
  if (!image) return null;
  
  // If it's a data URI (base64), use directly
  if (image.startsWith('data:')) {
    return image;
  }
  
  // If it's an absolute URL, use as-is
  if (image.startsWith('http')) {
    return image;
  }
  
  // Relative path - use as-is (assuming public folder)
  return image;
};

/**
 * Fetch with error handling
 */
const fetchWithErrorHandling = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Failed to fetch:', error);
    return [];
  }
};

/**
 * Posts API
 */
export const fetchPosts = async (options = {}) => {
  const { published = true, sort = 'date', limit } = options;
  const params = new URLSearchParams({
    published: published.toString(),
    sort,
    ...(limit && { limit: limit.toString() })
  });
  
  return fetchWithErrorHandling(`${API_BASE_URL}/api/v1/cms/posts?${params}`);
};

export const fetchPost = async (postId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/v1/cms/posts/${postId}`);
};

/**
 * Projects API
 */
export const fetchProjects = async (options = {}) => {
  const { published = true, sort = 'date', limit } = options;
  const params = new URLSearchParams({
    published: published.toString(),
    sort,
    ...(limit && { limit: limit.toString() })
  });
  
  return fetchWithErrorHandling(`${API_BASE_URL}/api/v1/cms/projects?${params}`);
};

export const fetchProject = async (projectId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/v1/cms/projects/${projectId}`);
};

/**
 * Jobs API - Already sorted by display_order!
 */
export const fetchJobs = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/v1/cms/jobs`);
};

export const fetchJob = async (jobId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/v1/cms/jobs/${jobId}`);
};

/**
 * Books API - Already sorted by display_order!
 */
export const fetchBooks = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/v1/cms/books`);
};

export const fetchBook = async (bookId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/v1/cms/books/${bookId}`);
};

